/* PM 10 Oct: add-to-cart confirmation for the LP layout (theme.pm-lp).
   Every add on the page (buy boxes, first screen, sticky bar, pair module, product cards)
   ends in a POST to /cart/add. When one finishes, this reads /cart.js, updates the header
   count and shows a confirmation with Checkout and View cart. Plain cart forms that would
   leave the page are sent with fetch instead, so the visitor stays on the LP. */
(function () {
  if (window.__pmLpCart) return;
  window.__pmLpCart = true;
  var t = null, hideT = null, el = null, lastAdd = 0;

  function money(c) {
    var n = Math.round((c || 0) / 100);
    return 'Rs. ' + n.toLocaleString('en-IN');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function bubble(count) {
    var a = document.getElementById('cart-icon-bubble');
    if (!a) return;
    var b = a.querySelector('.cart-count-bubble');
    if (!count) { if (b) b.remove(); return; }
    if (!b) {
      b = document.createElement('div');
      b.className = 'cart-count-bubble';
      a.appendChild(b);
    }
    b.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items in cart</span>';
    b.classList.remove('pmlc-bump'); void b.offsetWidth; b.classList.add('pmlc-bump');
  }
  function sideCartOpen() {
    var c = document.querySelectorAll('[id*="gokwik" i],[class*="gokwik" i],[id*="kwikcart" i],[class*="kwik-cart" i],[id*="gk-cart" i],[class*="gk-cart" i]');
    for (var i = 0; i < c.length; i++) {
      var r = c[i].getBoundingClientRect();
      var cs = getComputedStyle(c[i]);
      if (r.width > 240 && r.height > 300 && cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity > 0.1 && r.right > 0 && r.left < innerWidth) return true;
    }
    return false;
  }
  function hide() {
    if (!el) return;
    el.classList.remove('is-on');
    clearTimeout(hideT);
  }
  function show(cart) {
    var it = cart.items && cart.items[0];
    if (!it) return;
    if (!el) {
      el = document.createElement('div');
      el.className = 'pmlc';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
      el.addEventListener('click', function (e) {
        if (e.target.closest('.pmlc__x')) { hide(); }
        var v = e.target.closest('[data-pmlc-view]');
        if (v && typeof window.openGokwikSideCart === 'function') {
          try { e.preventDefault(); hide(); window.openGokwikSideCart(); } catch (err) { location.href = '/cart'; }
        }
      });
    }
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
    el.innerHTML =
      '<div class="pmlc__row">' +
        (img ? '<img class="pmlc__img" src="' + esc(img) + '" alt="" width="56" height="56">' : '<span></span>') +
        '<div><p class="pmlc__ok">&#10003; Added to cart</p><p class="pmlc__t">' + esc(it.product_title) + '</p>' +
        '<p class="pmlc__p">' + money(it.final_price) + ' · cart ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' · ' + money(cart.total_price) + '</p></div>' +
        '<button type="button" class="pmlc__x" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="pmlc__btns"><a class="pmlc__btn pmlc__btn--fill" href="/checkout">Checkout</a><a class="pmlc__btn pmlc__btn--line" href="/cart" data-pmlc-view>View cart</a></div>';
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    clearTimeout(hideT);
    hideT = setTimeout(hide, 9000);
  }
  function afterAdd() {
    clearTimeout(t);
    t = setTimeout(function () {
      getCart().then(function (cart) {
        bubble(cart.item_count);
        if (!cart.item_count) return;
        setTimeout(function () { if (!sideCartOpen()) show(cart); }, 350);
      }).catch(function () {});
    }, 250);
  }
  window.pmLpAfterAdd = afterAdd;

  // 1. Any request to /cart/add that completes (fetch or XHR, from any script).
  try {
    var po = new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (e) {
        if (/\/cart\/add(\.js)?(\?|$)/.test(e.name) && e.startTime > lastAdd) { lastAdd = e.startTime; afterAdd(); }
      });
    });
    po.observe({ type: 'resource', buffered: false });
  } catch (err) {}

  // 2. Plain cart forms (no theme script attached) would navigate to /cart. Send them with fetch.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f || !f.action || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (f.closest('product-form')) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(f);
    if (!fd.get('quantity')) fd.append('quantity', '1');
    fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { alert(res.j.description || res.j.message || 'Could not add to cart'); return; }
        afterAdd();
      })
      .catch(function () { f.submit(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') hide(); });
})();
